// export default () => ({
// })

export default () => ({
    productlot: [],
    productlotSelectable: [],
    productlotPaginatedData: null,
    lot: null,
    isLoading: false,
    isCreating: false,
    createdData: null,
    isUpdating: false,
    updatedData: null,
    isDeleting: false,
    deletedData: null,
    isFindingProductlot: false,
    findProductlot: null,
    productlotListByClientSelectable: [],
    isLoadingProductlotListByClient: false,
    findProductlotExist: null
})